import { annotatorClient } from './annotatorClient';
import type { AppSettings } from '../types/annotator';

export async function getAnnotatorSettings(): Promise<AppSettings> {
  return annotatorClient.get<AppSettings>('/settings');
}

export async function updateAnnotatorSettings(data: Partial<AppSettings>): Promise<AppSettings> {
  return annotatorClient.put<AppSettings>('/settings', data);
}
